import {
  DELETE_VACCINATION_STATEMENT_SUCCESS,
  DELETE_VACCINATION_STATEMENT_FAILURE,
  DELETE_VACCINATION_STATEMENT_REQUEST,
} from "../constants/MyM";
import { deleteApi } from "../../utils/apiCall";
import { apiToastError, apiToastSuccess } from "../../utils/MyMUtils";

const deleteVaccinationStatementSuccess = (data) => {
  return {
    type: DELETE_VACCINATION_STATEMENT_SUCCESS,
    payload: data,
  };
};

const deleteVaccinationStatementFailure = (data) => {
  return {
    type: DELETE_VACCINATION_STATEMENT_FAILURE,
    payload: data,
  };
};

export const deleteVaccinationStatementRequest = () => ({
  type: DELETE_VACCINATION_STATEMENT_REQUEST,
});

export const deleteVaccinationStatement = (id, facilityId) => {
  return async (dispatch, getState) => {
    dispatch(deleteVaccinationStatementRequest());
    const { error, result } = await deleteApi(`/vaccination_statement/${id}`, {
      facility_id: facilityId,
      vaccination_type_id: "1"
    });
    if (!error) {
      apiToastSuccess(result);
      return dispatch(deleteVaccinationStatementSuccess(result));
    } else {
      apiToastError(result);
      return dispatch(deleteVaccinationStatementFailure(result));
    }
  };
};